<template>
  <div>
    <b-form-group :class="{'zero-margin-bottom': zeroMarginBottom, 'align-left': alignLeft, 'width-50': width50, 'width-25': width25, 'inline-Block': inlineBlock, 'tooltip-width': tooltip}" :label="label" :label-for="id" :description="description">
      <b-form-input :class="{'border-none': borderNone}" v-if="!hasAppendSlot" :type="type" :id="id" v-model="localValue" :maxlength="maxlength" :placeholder="placeholder" :readonly="readonly" :autocomplete="autocomplete" :state="state" v-bind="dataAttributes" @keyup="$emit('keyup', $event)" :size="size" :min="min" :max="max" :disabled="disabled" @click="$emit('click', $event)" @blur="$emit('blur', $event)" :step="step" @keydown.enter="enterEventAction ? enterEventAction() : null">
      </b-form-input>
      <b-input-group v-else>
        <b-form-input :class="{'border-none': borderNone}" :type="type" :id="id" v-model="localValue" :placeholder="placeholder" :maxlength="maxlength" :readonly="readonly" :state="state" v-bind="dataAttributes" :autocomplete="autocomplete" @keyup="$emit('keyup', $event)" :size="size" :min="min" :max="max" :disabled="disabled" :step="step" @keydown.enter="enterEventAction ? enterEventAction() : null">
        </b-form-input>
        <b-input-group-append v-if="hasAppendSlot">
        <b-input-group-text>
          <slot name="append"></slot>
        </b-input-group-text>
      </b-input-group-append>
      <vuelidate-error :state="state" :validator="validator" :requiredErrorMsg="requiredErrorMsg">
      </vuelidate-error>
      </b-input-group>
    </b-form-group>
    <b-icon-question-circle v-if="tooltip" v-b-tooltip.hover v-b-tooltip.click="tooltip" :title="tooltip"></b-icon-question-circle>
    <b-form-text v-if="inputInfoText">{{ inputInfoText }}</b-form-text>
  </div>
</template>

<script>
import { BTooltip, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BInputGroupText, BFormInvalidFeedback, BFormText } from 'bootstrap-vue'
import VuelidateError from '@/components/base/forms/VuelidateError'

const compName = 'base-input'

export default {
  name: compName,
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
    BFormInvalidFeedback,
    BTooltip,
    VuelidateError,
    BFormText
  },
  props: {
    value: [String, Number],
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default () {
        return this.$t('base-input.placeholder')
      }
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    requiredErrorMsg: {
      type: String,
      required: false,
      default () {

      }
    },
		errorMsg: {
			type: String,
			required: false
		},
    validator: {
      type: Object,
      required: false,
      default: null
    },
    dataAttributes: {
      type: Object,
      required: false,
      default: null
    },
    zeroMarginBottom: {
      type: Boolean
    },
    alignLeft: {
      type: Boolean
    },
    width50: {
      type: Boolean
    },
    autocomplete: {
      type: String
    },
    tooltip: String,
    inlineBlock: Boolean,
    width25: Boolean,
    min: Number,
    max: Number,
    step: Number,
    name: String,
    size: {
      type: String,
      default: 'md'
    },
    inputInfoText: {
      type: String,
      required: false,
      default: null
    },
    borderNone: Boolean,
    disabled: Boolean,
    enterEventAction: Function,
    maxlength: Number
  },
  data () {
    return {
      id: null,
      localValue: null
    }
  },
  mounted () {
    this.id = `${compName}${this._uid.toString()}`
  },
  created () {
    this.localValue = this.value
    this.$watch('value', value => {
      this.localValue = value
    })
    this.$watch('localValue', value => {
      this.$emit('input', value)
      this.$emit('change', value)
    })
  },
  computed: {
    hasAppendSlot () {
      return this.$slots.append !== undefined
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.zero-margin-bottom {
  margin-bottom: 0px !important;
}
/deep/.align-left {
  width: 100%;
  label {
    margin-left: 1%;
    text-align: left;
  }
  @include media(desktop, tablets) 
  {
    width: 30%;
  }
}
/deep/.width-50 {
  width: 50%;
  @include media(mobile, tablets) {
    width: 95%;
  }
}
.width-25 {
  width: 25%;
  @include media(mobile, tablets) {
    width: 95%;
  }
}
.input-center {
  display: block;
  margin: auto;
}
.inline-Block {
  display: inline-block;
}
.tooltip-width {
  display: inline-block;
  width: 90%;
}

/deep/ label {
  padding-left: 1rem;
  text-align: center;
}
.border-none{
  border: none;
  &:focus{
    box-shadow: none;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/base/forms/BaseInput.vue